import {ADataGridColumn} from "@atiautomacao/ati-ui-library";

const sortableFilter = (name: string) => ({
    name,
    condition: 'contains',
    value: '',
    sort: 'none' as const,
});

export const performanceAnalysisColumns = [
    {
        name: 'powerStationName',
        label: 'UFV',
        align: 'left',
        width: '180px',
        minWidth: 180,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('powerStationName'),
    },
    {
        name: 'communicationState',
        label: 'Comunicação da usina',
        align: 'left',
        width: '153px',
        minWidth: 153,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'communicationState', condition: 'equals', value: '', sort: 'none'}
    },
    {
        name: 'alarmSummary',
        label: 'Alarmes ativos',
        align: 'left',
        width: '200px',
        minWidth: 200,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'powerCapacityNominal',
        label: 'kWp',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('powerCapacityNominal'),
    },
    {
        name: 'instantPower',
        label: 'Potência (kW)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('instantPower'),
    },
    {
        name: 'instantIrradiance',
        label: 'Irradiância (W/m²)',
        align: 'left',
        minWidth: 100,
        width: '100px',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('instantIrradiance'),
    },
    {
        name: 'powerIrradiance',
        label: 'Potência x Irradiância (dia)',
        align: 'left',
    	minWidth: 4,
        width: '2px',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'powerIrradiance', condition: 'contains', value: '', sort: 'undefined'},
    },
    {
        name: 'generatedEnergySum',
        label: 'Energia (MWh)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('generatedEnergySum'),
    },
    {
        name: 'performanceRatio',
        label: 'PR (%)',
        align: 'left',
        minWidth: 120,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'performanceRatio', condition: 'equals', value: '', sort: 'desc'}
    },
    {
        name: 'availability',
        label: 'Disponibilidade (%)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: sortableFilter('availability'),
    },
] as ADataGridColumn[];
